import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import customerFilterReducer from "./slices/customerFilterSlice";
import customerSearchFilterReducer from "./slices/customerSearchFilterSlice";
import userReducer from "./slices/userSlice";
import authReducer from "./slices/authSlice";
import workPanelReducer from "./slices/workPanelSlice";
import activityPanelReducer from "./slices/activityPanelSlice";
import { baseApi } from "./api/baseApi";
import msBaseApi from "./api/msBaseApi";
import { currentUserMiddleware, initializeCurrentUser } from "./middleware/currentUserMiddleware";

const store = configureStore({
  reducer: {
    auth: authReducer,
    [msBaseApi.reducerPath]: msBaseApi.reducer,
    customerFilter: customerFilterReducer,
    customerSearchFilter: customerSearchFilterReducer,
    user: userReducer,
    [baseApi.reducerPath]: baseApi.reducer,
    workPanel: workPanelReducer,
    activityPanel: activityPanelReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(currentUserMiddleware.middleware)
      .concat(baseApi.middleware, msBaseApi.middleware),
});

setupListeners(store.dispatch);

// Initialize current user on app start if authenticated
store.dispatch(initializeCurrentUser() as any);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
